import { render, staticRenderFns } from "./package-dialog.vue?vue&type=template&id=471f6df2"
import script from "./package-dialog.vue?vue&type=script&lang=js"
export * from "./package-dialog.vue?vue&type=script&lang=js"
import style0 from "./package-dialog.vue?vue&type=style&index=0&id=471f6df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports